module.exports = __webpack_public_path__ + "img/dark_ic_new_video.2d5c8d96.png";